// Add your custom JS here.
(function(){
    function onReady() {
        document.body.classList.remove('no-scroll');
        window.scrollTo(0,0);
    }

    if ( document.readyState === 'complete' ) {
        onReady();
    } else {
        document.addEventListener('DOMContentLoaded', onReady);
    }

})();

jQuery(function($) {


    $("select[name=\"subject\"] option:first").addClass('placeholder-option');//.attr('disabled', 'disabled');
});

var initializeOneSlideMobile = function( $block ) {
    if( jQuery(window).width() < 743 ) {

        if(!$block.hasClass('slick-initialized')) {
            $block.slick({
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            });
        }
    }

    else {

        if($block.hasClass('slick-initialized')) {
            $block.slick('unslick');
        }

    }

}
jQuery(document).ready(function(){
    jQuery('.content-max-height .read-more a').on('click', function (e) {
        e.preventDefault();
        jQuery(this).closest('.content-max-height').toggleClass('open');
        jQuery(this).closest('.read-more').addClass('d-none');

    });

    jQuery('.related-posts').each(function(){
        initializeOneSlideMobile( jQuery(this) );
    });

    jQuery(window).on('resize', function(){
        jQuery('.related-posts').each(function(){
            initializeOneSlideMobile( jQuery(this) );
        });

    });


    if (!BIMI_STORAGE['post_views_counter_inited'] && jQuery('body').hasClass('single-post')) {
        BIMI_STORAGE['post_views_counter_inited'] = true;
        setTimeout(function() {
            let data = {
                action: 'post_counter',
                nonce: BIMI_STORAGE['ajax_nonce'],
                post_id: BIMI_STORAGE['post_id'],
                views2: 1,
                views: 1
            };
            jQuery.post(BIMI_STORAGE['ajax_url'], data).done(function(response) {
                var rez = {};
                try {
                    rez = JSON.parse(response);
                } catch (e) {
                    rez = { error: BIMI_STORAGE['ajax_error'] };
                    console.log(response);
                }
                if (rez.error === '') {
                    jQuery('.entry-meta .views-count .views').html(rez.counter);
                }

            });
        }, 10);
    }

    jQuery(".copy-link").click(function (event) {
        event.preventDefault();

        let text = jQuery(this).data('copy-link-url');
        let mess = jQuery(this).data( 'message');
        CopyToClipboard(jQuery(this), text, true, mess);
    });

    if(jQuery('body').hasClass('single-post')){
        jQuery(window).on('resize', function(){
            initializeRelatedPosts( jQuery('.single .related-posts') );
        });

        initializeRelatedPosts( jQuery('.single .related-posts') );
    }
    if(jQuery('.wpcf7 select.wpcf7-select').length > 0){

        jQuery('.wpcf7 select.wpcf7-select').selectmenu();

    }


});
var initializeRelatedPosts = function( $block ) {
    if( jQuery(window).width() < 744 ) {

        if(!$block.hasClass('slick-initialized')) {
            $block.slick({
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            });
        }
    }

    else {

        if($block.hasClass('slick-initialized')) {
            $block.slick('unslick');
        }

    }

}




function CopyToClipboard($element, value, showNotification, notificationText) {
    var $temp = jQuery("<input>");
    jQuery("body").append($temp);
    $temp.val(value).select();
    document.execCommand("copy");
    $temp.remove();

    if (typeof showNotification === 'undefined') {
        showNotification = true;
    }
    if (typeof notificationText === 'undefined') {
        notificationText = "Copied!";
    }

    var notificationTag = jQuery("span.copy-notification");
    if (showNotification && notificationTag.length == 0) {
        notificationTag = jQuery("<span/>", { "class": "copy-notification position-absolute top-0 start-50 translate-middle badge  bg-light text-dark", text: notificationText });
        $element.append(notificationTag);

        notificationTag.fadeIn("slow", function () {
            setTimeout(function () {
                notificationTag.fadeOut("slow", function () {
                    notificationTag.remove();
                });
            }, 1000);
        });
    }
}

/***/
jQuery(document).ready(function(){

    if( jQuery('#screenshots-slider-single-app').length > 0 ) {
        jQuery('#screenshots-slider-single-app').on('init', function () {
            jQuery(this).css({
                'visibility': 'visible',
                'max-height': '100%',
                'overflow': 'initial'
            });
        });

        if(!jQuery('#screenshots-slider-single-app').hasClass('slick-initialized')) {
            jQuery('#screenshots-slider-single-app').slick({
                dots: true,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                adaptiveHeight: true,
                responsive: [

                    {
                        breakpoint: 744,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                            arrows:false ,
                        }
                    }
                ]
            });
        }
    }


    let searchBtn = jQuery('.search');
    let searchInput = jQuery('.search-field');

    searchBtn.on('click', function (){
        setTimeout(function () {searchInput.focus();}, 400);

    });

    if ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        if(jQuery(window).width() < 1279){
            jQuery('.app-video').css("display","none");
            jQuery('.app-video-mobile').css("display","block").css('border-radius','60px');
        }else{
            jQuery('.app-video').css("display","block");
            jQuery('.app-video-mobile').css("display","none");
        }

    }else{
        jQuery('.app-video').css("display","block");
        jQuery('.app-video-mobile').css("display","none");
    }

    jQuery('#exampleModal').on('hide.bs.modal', function (event) {
        jQuery('#modal-video').get(0).pause();
    })


});
jQuery( window ).on( "load", function() {
    jQuery(window).trigger('resize');
});